









import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere

import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-diff';
import 'prismjs/themes/prism-funky.css'; // import syntax highlighting styles

@Component({
    components: { PrismEditor }
})
export default class GitDiffHighlighter extends Vue {
    @Prop({ required: true, type: String })
    value!: string;

    internalValue: string = this.value;

    @Watch('value')
    onValueChange(value: string) {
	    this.internalValue = value;
    }

    onInternalValueChange(value: string) {
	    this.$emit('input', value);
    }

    highlighter(code: string) {
        return highlight(code, languages.diff);
    }
}
